module.exports = __webpack_public_path__ + "img/picc.e7090499.png";